import { produce } from 'immer';

import { ShortPathDataState } from './state.interface';
import { ShortPathDataActionsType } from './actions';
import { ActionType } from 'app/store/actionTypes';

const initialState: ShortPathDataState = {
  cepikData: null,
  mergeData: null,
  isCepikDataRejected: null,
  isCepikDataRejectionModalOpened: false,
  isCepikModalSavingInProgress: null,
  quotationWithCepikData: null,
  lastRegistrationNumberWithReturnedData: null,
};

const ShortPathDataReducer = (
  state: ShortPathDataState = initialState,
  action: ShortPathDataActionsType
) =>
  produce(state, (draft) => {
    if (action.type === ActionType.SET_CEPIK_DATA) {
      draft.cepikData = action.payload;
    } else if (action.type === ActionType.SET_CEPIK_MERGE_DATA) {
      draft.mergeData = action.payload;
    } else if (action.type === ActionType.CLEAR_CEPIK_DATA) {
      return {
        ...initialState,
        lastRegistrationNumberWithReturnedData:
          state.lastRegistrationNumberWithReturnedData,
      };
    } else if (action.type === ActionType.CLEAR_SHORT_PATH_DATA) {
      return initialState;
    } else if (action.type === ActionType.SET_QUOTATION_WITH_CEPIK_DATA) {
      draft.quotationWithCepikData = action.payload;
    } else if (action.type === ActionType.SET_CEPIK_MODAL_SAVING_IN_PROGRESS) {
      draft.isCepikModalSavingInProgress = action.payload;
    } else if (action.type === ActionType.SET_CEPIK_DATA_REJECTED) {
      draft.isCepikDataRejected = true;
    } else if (
      action.type === ActionType.SET_IS_CEPIK_DATA_REJECTION_MODAL_OPENED
    ) {
      draft.isCepikDataRejectionModalOpened = action.payload;
    } else if (
      action.type === ActionType.SET_LAST_REGISTRATION_NUMBER_WITH_RETURNED_DATA
    ) {
      draft.lastRegistrationNumberWithReturnedData = action.payload;
    } else {
      return state;
    }
  });

export default ShortPathDataReducer;
